import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../partials/Container'
import CommunityCreator from '../../partials/CommunityCreator'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

const PAYMENT_TYPE = [
  { name: 'paypal', label: 'PayPal', address: true },
  { name: 'crypto', label: 'Crypto', address: true },
  { name: 'wire', label: 'Bankwire', comment: 'Email us your bank details' }
]

const CRYPTO_TYPES = [
  { short: 'btc', name: 'Bitcoin' },
  // { short: 'btg', name: 'Bitcoin Gold' },
  // { short: 'bch', name: 'Bitcoin Coin' },
  { short: 'eth', name: 'Ethereum' },
  // { short: 'etc', name: 'Ethereum Classic' },
  { short: 'ltc', name: 'Litecoin' }
  // { short: 'doge', name: 'DOGE' }
]

@inject('Community', 'Config')
@observer
export class CommunityUser extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        name: '',
        seo: '',
        url: '',
        paymentType: 0,
        cryptoType: 0,
        paymentAddress: ''
      }
    }
  }

  onSaveClick (e) {
    const paymentType = PAYMENT_TYPE[+this.state.editor.paymentType]
    const cryptoType = CRYPTO_TYPES[+this.state.editor.cryptoType]

    this.props.Community.postCommunity({
      name: this.state.editor.name,
      seo: this.state.editor.seo,
      url: this.state.editor.url,
      payment: {
        type:
          paymentType.name === 'crypto' ? cryptoType.short : paymentType.name,
        ...(paymentType.name !== 'wire'
          ? { address: this.state.editor.paymentAddress }
          : {})
      }
    })
      .then(() => {
        console.log('successful')
        this.props.history.push(
          this.props.location.pathname.replace('/new', '')
        )
      })
      .catch(e => console.log('err', e))
      .then(res => console.log('res', res))
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(style.headers.h2)}>Create Community</h2>
          </Col>
          <Col>
            <Row>
              <Col />
              <Col>
                <span
                  onClick={this.onSaveClick.bind(this)}
                  className={css(style.buttons.button, style.buttons.red)}
                >
                  Save
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <CommunityCreator
            PAYMENT_TYPE={PAYMENT_TYPE}
            CRYPTO_TYPES={CRYPTO_TYPES}
            theme={THEME_LIST[this.props.Config.theme]}
            response={this.props.Community.response.create}
            editor={this.state.editor}
            onSaveClick={this.onSaveClick.bind(this)}
            onInputChange={this.onInputChange.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export default CommunityUser



// WEBPACK FOOTER //
// ./src/components/Community/Main/Create/index.js